// capture whitelabel only once

const LOGIN_MODAL_EVENTS = {
  MODAL_VISIBILITY: "MODAL_VISIBILITY"
};
const MODAL_STATUS = {
  INITIALIZED: "initialized",
  CONNECTED: "connected",
  CONNECTING: "connecting",
  ERRORED: "errored"
};
let TOAST_TYPE = /*#__PURE__*/function (TOAST_TYPE) {
  TOAST_TYPE["SUCCESS"] = "success";
  TOAST_TYPE["ERROR"] = "error";
  TOAST_TYPE["WARNING"] = "warning";
  TOAST_TYPE["INFO"] = "info";
  return TOAST_TYPE;
}({});

export { LOGIN_MODAL_EVENTS, MODAL_STATUS, TOAST_TYPE };
